import { STORE_REPLACE_PAYSTUB } from '@perpay-web/fintech/constants/actionTypes';

const initialState = {};

const paystubReducer = (state = initialState, action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case STORE_REPLACE_PAYSTUB:
            return { ...payload };
        default:
            return state;
    }
};

export default paystubReducer;
